import React, { FC, useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import useSWR from 'swr'

import T from 'components/FormattedMessage'
import { IPlayer, CreateGameResponse } from 'protos'
import GameCreationScreen from 'components/GameCreationScreen'
import { getClassicPlayers, joinClassicGame } from 'services/gamelogic'

import SelectClassicPlayersTeamEditor from './SelectClassicPlayersTeamEditor'

const SelectClassicPlayersContainer: FC = () => {
  const search = new URLSearchParams(useLocation().search)
  const gameId = search.get('game')

  const { replace, goBack } = useHistory()

  const fetchClassicPlayers = useCallback(() => getClassicPlayers(gameId!), [gameId])
  const { isValidating, error, data } = useSWR(gameId ? `classicplayers_${gameId}` : null, fetchClassicPlayers)

  const [submitting, setSubmitting] = useState(false)
  const [submitError, setSubmitError] = useState<any>()
  const dismissSubmitError = useCallback(() => setSubmitError(undefined), [])
  const onSubmit = useCallback(async (players: IPlayer[]) => {
    if (!gameId) return

    try {
      setSubmitting(true)

      const response = await joinClassicGame(gameId, players.map(player => player.playerId!))

      if (response.result && response.result === CreateGameResponse.Result.CGR_SUCCESS) {
        replace(`/games/${gameId}`)
      } else {
        setSubmitError(response.toJSON().result)
      }
    } catch (error) {
      setSubmitError(error)
    } finally {
      setSubmitting(false)
    }
  }, [gameId, replace])

  if (!gameId) {
    return (
      <GameCreationScreen
        title={<T id="teameditor_title" />}
        onBack={goBack}
        errorCode="No game selected."
      />
    )
  }

  return (
    <GameCreationScreen
      title={<T id="teameditor_title" />}
      onBack={goBack}
      component={SelectClassicPlayersTeamEditor}
      componentProps={{
        isLoading: isValidating && !data,
        error,
        gameId,
        data: data && {
          groups: data.group,
        },
        submitting,
        submitError,
        onSubmit,
        dismissSubmitError,
      }}
    />
  )
}

export default SelectClassicPlayersContainer
try {
    // @ts-ignore
    SelectClassicPlayersContainer.displayName = "SelectClassicPlayersContainer";
    // @ts-ignore
    SelectClassicPlayersContainer.__docgenInfo = { "description": "", "displayName": "SelectClassicPlayersContainer", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/routes/SelectClassicPlayers/SelectClassicPlayersContainer.tsx#SelectClassicPlayersContainer"] = { docgenInfo: SelectClassicPlayersContainer.__docgenInfo, name: "SelectClassicPlayersContainer", path: "src/routes/SelectClassicPlayers/SelectClassicPlayersContainer.tsx#SelectClassicPlayersContainer" };
}
catch (__react_docgen_typescript_loader_error) { }